module.exports = __webpack_public_path__ + "static/img/246_TO8_2197.f6cdf8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/246_TO8_2197.jpg
// module id = P4mf
// module chunks = 0